import React, { useEffect, useState } from 'react';
import { FormCheckbox } from 'shards-react';
import type { ICellRendererParams } from 'ag-grid-community';
import type { ConditionOptionsData, ConditionOptionsType } from '../../types/condition';
import { RootState, useDispatch, useSelector } from '../../redux/store';
import { addOptionToConditionCustomize, removeOptionFromConditionCustomize } from '../../redux/slices/condition';
import { MANAGE_CONDITION_TYPES } from '../../constants';
import getOptionsRowNodeId from '../../utils/manage-condition/getOptionsRowNodeId';

/**
 * ConditionOptionsのチェックボックス用レンダラ
 * @param params: ICellRendererParams
 * @returns React.ReactElement
 */
const SelectConditionOptionRenderer = (params: ICellRendererParams): React.ReactElement => {
  // console.log(params);
  const dispatch = useDispatch();
  const data: ConditionOptionsType = params.data;
  const { condition } = useSelector((state: RootState) => state.condition);
  const [isChecked, setIsChecked] = useState<boolean>(false);
  const detail: ConditionOptionsData | undefined = condition
    ? {
        ...data,
        conditionId: condition.id,
        conditionType: MANAGE_CONDITION_TYPES.CUSTOMIZE,
      }
    : undefined;

  // SIDE EFFECT
  // ================================================================================

  /**
   * そのConditionOptionがConditionCustomizeにあるかどうか調べて初期のチェック状態を決める
   */
  useEffect(() => {
    const rowNodeId: string = getOptionsRowNodeId(data);
    const sameDetailCustomize: ConditionOptionsData | ConditionOptionsType | undefined = condition?.detailCustomize?.find((detail) => {
      if (rowNodeId === getOptionsRowNodeId(detail)) {
        return true;
      } else {
        return false;
      }
    });
    if (sameDetailCustomize !== undefined) {
      setIsChecked(true);
    }
  }, []);

  /**
   * ConditionCustomizeが変わったら自分と同じものがあるか調べてチェック状態を変える
   */
  useEffect(() => {
    const rowNodeId: string = getOptionsRowNodeId(data);
    const sameDetailCustomize: ConditionOptionsData | ConditionOptionsType | undefined = condition?.detailCustomize?.find((detail) => {
      if (rowNodeId === getOptionsRowNodeId(detail)) {
        return true;
      } else {
        return false;
      }
    });
    if (sameDetailCustomize === undefined) {
      setIsChecked(false);
    }
  }, [condition?.detailCustomize]);

  // EVENT HANDLER
  // ================================================================================

  const handleChange = (): void => {
    // unchecked -> checkedの場合
    if (detail && !isChecked) {
      dispatch(addOptionToConditionCustomize(detail));
      // checked -> uncheckedの場合
    } else if (detail && isChecked) {
      dispatch(removeOptionFromConditionCustomize(detail));
    } else {
      // do nothing
    }
    setIsChecked(!isChecked);
  };

  // VIEW
  // ================================================================================

  return (
    <div className="text-center">
      <FormCheckbox className="m-0" size="sm" inline checked={isChecked} onChange={handleChange} />
    </div>
  );
};

export default SelectConditionOptionRenderer;
